import { Action } from "redux"

import * as actions from "./actions"
import { IAuth } from "./index"

export const initialState: IAuth = {
    basePage: {
        logoUrl: "",
    },
    loginPage: {
        username: "",
        password: "",
        remember: false,
        incompatibleErrorMessage: "",
        loginErrorMessage: "",
        underMaintenanceErrorMessage: "",
        isLoading: false,
    },
    logoutPage: {
        errorMessage: "",
    },
    recoverPasswordPage: {
        email: "",
        errorMessage: "",
        showSuccess: false,
        isLoading: false,
    },
}

const handlers: {
    [action: string]: (state: IAuth, props: Action) => IAuth
} = {
    [actions.RECEIVE_LOGO]: (
        state,
        { logoUrl }: actions.ReceiveLogo,
    ): IAuth => ({ ...state, basePage: { ...state.basePage, logoUrl } }),

    [actions.RECEIVE_DATABASE_VERSION_ERROR]: (
        state,
        { errorMessage }: actions.ReceiveError,
    ): IAuth => ({
        ...state,
        loginPage: {
            ...state.loginPage,
            incompatibleErrorMessage: errorMessage,
        },
    }),

    [actions.RECEIVE_DATABASE_VERSION_SUCCESS]: (state): IAuth => ({
        ...state,
        loginPage: { ...state.loginPage, incompatibleErrorMessage: "" },
    }),

    [actions.RECEIVE_MAINTENANCE_ERROR]: (
        state,
        { errorMessage }: actions.ReceiveError,
    ): IAuth => ({
        ...state,
        loginPage: {
            ...state.loginPage,
            underMaintenanceErrorMessage: errorMessage,
        },
    }),

    [actions.RECEIVE_MAINTENANCE_SUCCESS]: (state): IAuth => ({
        ...state,
        loginPage: { ...state.loginPage, underMaintenanceErrorMessage: "" },
    }),

    [actions.RECEIVE_LOGIN_ERROR]: (
        state,
        { errorMessage }: actions.ReceiveError,
    ): IAuth => ({
        ...state,
        loginPage: {
            ...state.loginPage,
            password: "",
            loginErrorMessage: errorMessage,
            isLoading: false,
        },
    }),

    [actions.REQUEST_LOGIN]: (
        state,
        { username, password, remember }: actions.RequestLogin,
    ): IAuth => ({
        ...state,
        loginPage: {
            ...state.loginPage,
            username,
            password,
            remember,
            loginErrorMessage: "",
            isLoading: true,
        },
    }),

    [actions.RECEIVE_LOGOUT_ERROR]: (
        state,
        { errorMessage }: actions.ReceiveError,
    ): IAuth => ({
        ...state,
        logoutPage: { ...state.logoutPage, errorMessage },
    }),

    [actions.RECEIVE_RESTORE_PASSWORD_ERROR]: (
        state,
        { errorMessage }: actions.ReceiveError,
    ): IAuth => ({
        ...state,
        recoverPasswordPage: {
            ...state.recoverPasswordPage,
            errorMessage,
            showSuccess: false,
            isLoading: false,
        },
    }),

    [actions.RECEIVE_RESTORE_PASSWORD_SUCCESS]: (state): IAuth => ({
        ...state,
        recoverPasswordPage: {
            ...state.recoverPasswordPage,
            errorMessage: "",
            showSuccess: true,
            isLoading: false,
        },
    }),

    [actions.REQUEST_RESTORE_PASSWORD]: (
        state,
        { email }: actions.RequestRestorePassword,
    ): IAuth => ({
        ...state,
        recoverPasswordPage: {
            ...state.recoverPasswordPage,
            email,
            isLoading: true,
        },
    }),
}

export default function reducer(
    state: IAuth = initialState,
    action: Action,
): IAuth {
    const handler: (state: IAuth, action: Action) => IAuth =
        handlers[action.type]
    return handler ? handler(state, action) : state
}
